import React, { FunctionComponent } from 'react'
import { Text } from '@afterpaytouch/core'
import { Trans } from '../../../utils/convergence'
import { AssetChildComponentSpacing } from './types'
import { getSpacingClassName } from './helper'

interface Props extends AssetChildComponentSpacing {
  label?: string
  show?: boolean
}

export const SecondaryTitle: FunctionComponent<Props> = ({ label = '', show = false, margin, marginBottom, marginTop }) => {
  if (!show || !label) {
    return null
  }

  return (
    <div className={getSpacingClassName({ margin, marginBottom, marginTop })}>
      <Text size='XS'>
        <Trans
          i18nKey={label}
          defaults=''
          components={{
            b: <strong />,
          }}
        />
      </Text>
    </div>
  )
}
